import React from "react";
import { Landmark, Copy } from "lucide-react";
import { toast } from "sonner";
import { BANK_DETAILS } from "../lib/constants";

export default function BankDetails({ reference }) {
  const rows = [
    ["Account Name", BANK_DETAILS.accountName],
    ["Sort Code", BANK_DETAILS.sortCode],
    ["Account Number", BANK_DETAILS.accountNumber],
  ];
  if (reference) rows.push(["Reference", reference]);

  const copy = () => {
    const text = rows.map(([k, v]) => `${k}: ${v}`).join("\n");
    navigator.clipboard?.writeText(text);
    toast.success("Bank details copied");
  };

  return (
    <div data-testid="bank-details" className="rounded-2xl bg-[#E8F5E9] border border-[#BBF7D0] p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-[#1A4331]">
          <Landmark size={20} />
          <h3 className="font-semibold">Bank Transfer Payment</h3>
        </div>
        <button
          data-testid="copy-bank-details"
          onClick={copy}
          className="flex items-center gap-1 text-xs font-semibold text-[#166534] hover:underline"
        >
          <Copy size={14} /> Copy
        </button>
      </div>
      <p className="text-sm text-[#166534] mb-3">Please make payment to:</p>
      <div className="space-y-1.5">
        {rows.map(([k, v]) => (
          <div key={k} className="flex justify-between text-sm">
            <span className="text-gray-500">{k}</span>
            <span className="font-semibold text-[#0A1F13]">{v}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
